
























import { computed, defineComponent, toRef } from "@vue/composition-api";
import { isTipMessageDetails, TipMessageDetails } from "@scrile/api-provider/dist/api/TipProvider";
import { Message } from "@scrile/api-provider/dist/projects/scrileConnect/MessagesProvider";
import useMessageView from "@/hooks/useMessageView";
import BaseIcon from "@/components/Base/BaseIcon";
import FormatMoney from "@/components/FormatMoney";
import MessageItemLink from "../components/MessageItemLink";

export default defineComponent({
  name: "SystemMessageTip",
  inheritAttrs: false,
  components: { FormatMoney, BaseIcon, MessageItemLink },
  props: {
    message: { type: Object as () => Message, required: true },
    markAsSeen: { type: Boolean, required: true },
  },
  setup(props) {
    const { isOpponentMessage, hoursMinutes, fullTime } = useMessageView(toRef(props, "message"));
    const details = computed<TipMessageDetails | null>(() =>
      isTipMessageDetails(props.message.details) ? props.message.details : null
    );
    return { isOpponentMessage, hoursMinutes, fullTime, details };
  },
});
